<template>
	<div class="header">
		<!-- 折叠按钮 -->

		<!-- <div class="logo" @click="collapseChage" style="cursor: pointer;">
           <img src="../../assets/img/logo.png" alt="logo">
		   phone:"",
		   lastpassword:"",
		   password:"",
		   surepassword:""
       </div> -->
		<el-dialog title="修改密码" :visible.sync="fixpassdiag" :close-on-click-modal="false" append-to-body v-dialogDrag>
			<el-form :model="forgetparam" ref="forgetparam" :rules="forgetrules" label-width="0px">
				<div class="Verticalcenter-line forgetall">
					<!--<div>
	 			<img  src="../../assets/img/forget2.png"/>
	 			<el-form-item prop="phone"><el-input v-model="forgetparam.phone" placeholder="请输入手机号" class=""></el-input></el-form-item>
	 		</div>-->
					<div>
						<img src="../../assets/img/forget4.png" />
						<el-form-item prop="lastpassword">
							<el-input v-model="forgetparam.lastpassword" type="password" placeholder="请输入原密码" class=""></el-input>
						</el-form-item>
					</div>
					<div>
						<img src="../../assets/img/forget4.png" />
						<el-form-item prop="password"><el-input v-model="forgetparam.password" placeholder="请输入新密码" class="" type="password"></el-input></el-form-item>
					</div>
					<div>
						<img src="../../assets/img/forget3.png" />
						<el-form-item prop="surepassword">
							<el-input v-model="forgetparam.surepassword" type="password" placeholder="请再次输入密码" class=""></el-input>
						</el-form-item>
					</div>
				</div>
			</el-form>
			<div style="margin-top: 18px;padding-bottom: 21px;" class="between-line">
				<div></div>
				<div class="rightbuttom">
					<div @click="forchoose">确定</div>
					<div @click="fixpassdiag = false">取消</div>
				</div>
			</div>
		</el-dialog>

        <el-dialog title='税局登录' :visible.sync='taxBureauLoginDialog' :close-on-click-modal='false'>
            <el-form ref="form" :model="taxBureauLoginForm" label-width="90px" style='padding: 50px 100px 50px 100px;'>
                <el-form-item label="税号">
                    <el-input v-model="taxBureauLoginForm.nasrsbh" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="税局用户名">
                    <el-input v-model="taxBureauLoginForm.loginAccount" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="登录密码">
                    <el-input v-model="taxBureauLoginForm.loginPassword" :disabled="true" show-password></el-input>
                </el-form-item>
                <el-form-item label="验证码">
                    <el-input v-model="taxBureauLoginForm.smsCode" :maxlength='6' onkeyup="this.value = this.value.replace(/\D/g,'')" placeholder="请输入验证码"></el-input>
                </el-form-item>
                <div style='justify-content: right;display: flex;'>
                    <el-link type="primary" @click='sendSmsCode'>发送验证码</el-link>
                </div>

                <div style="justify-content: center; display: flex;margin-top: 30px;">
                    <div class="addstyle" @click="taxBureauLoginSubmit" style="width: 80px;margin-left: 20px;">提交</div>
                    <div class="backstyle" style="width: 80px;margin-left: 20px;" @click="closeTaxBureauLoginDialog">关闭</div>
                </div>
            </el-form>
        </el-dialog>

		<div v-if="projectName == 'WGQ'">
			<div class="collapse-btn" @click="collapseChage" style="margin-left: 20px;">
				<i v-if="!collapse" class="el-icon-s-fold"></i>
				<i v-else class="el-icon-s-unfold"></i>
			</div>
			<div class="logo"><img :src="require('../../assets/img/' + jllogoImg)" v-if="notemptyandnull(jllogoImg)" style="width: 98px;height: 38px;" /></div>
		</div>
		<div class="head-left" v-else>
			<img style="width: 90px;height: 28.7px;" src="../../assets/img/leftTou.svg" />
			<div style="margin-left: 10px;margin-right: 10px;font-size: 20px;font-weight: 400;">|</div>
			<div>销项平台</div>
		</div>
		<div class="header-right" v-if="projectName == 'WGQ'">
			<div class="header-user-con">
                <el-button v-if='taxBureauLoginBtnShowFlag' style='margin-right: 10px;' @click='taxBureauLogin'>税局登录</el-button>
				<el-select v-model="selectDataDef" filterable placeholder="请选择公司" style="margin-right: 30px;" @change="getSwitchCompany">
					<el-option  v-for="item in selectData" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<!-- 全屏显示 -->
				<div class="btn-fullscreen" @click="handleFullScreen">
					<el-tooltip effect="dark" :content="fullscreen ? `取消全屏` : `全屏`" placement="bottom"><i class="el-icon-rank"></i></el-tooltip>
				</div>
				<!-- 消息中心 -->
				<!--    <div class="btn-bell">
		                <el-tooltip
		                    effect="dark"
		                    :content="message?`有${message}条未读消息`:`消息中心`"
		                    placement="bottom"
		                >
		                    <router-link to="/tabs">
		                        <i class="el-icon-bell"></i>
		                    </router-link>
		                </el-tooltip>
		                <span class="btn-bell-badge" v-if="message"></span>
		            </div> -->
				<div class="user-avator"><img src="../../assets/img/head-log.png" /></div>
				<!-- <div class="header-right-box-out">
						<div style="line-height: 50px;width: 140px;">
							<el-select class="border" :placeholder="useropj.userCode" @change="handleCommand">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
							</el-select>
						</div>
					</div> -->
				<el-dropdown class="user-name" trigger="click" @command="handleCommand">
					<span class="el-dropdown-link">
						{{ useropj.userCode }}
						<i class="el-icon-caret-bottom"></i>
						<input type="hidden" id="tms_udesk" v-bind:data-id="userId" v-bind:data-username="userName" v-bind:data-nickname="nickName" />
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item divided command="fixpass">修改密码</el-dropdown-item>
						<el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		</div>

		<div class="header-right" v-else>
			<div class="header-user-con">
				<el-button v-if='taxBureauLoginBtnShowFlag' style='margin-right: 10px;' @click='taxBureauLogin'>税局登录</el-button>
				<el-select class="gongs" v-model="selectDataDef" filterable placeholder="请选择公司" style="margin-right: 30px; " @change="getSwitchCompany">
					<el-option  v-for="item in selectData" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
				<div class="header-right-box-out">
					<div style="line-height: 50px;width: 140px;">
						<el-select class="border" :placeholder="useropj.userName" @change="handleCommand">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
						</el-select>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import bus from '../common/bus';
import configHttp from '../../../configHttp.js';
export default {
	data() {
		var validatePass = (rule, value, callback) => {
			let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}$/;
			if (value == '') {
				callback(new Error('请输入密码'));
			} else if (!reg.test(value)) {
				callback(new Error('密码需包含大小写字母、数字且大于8位'));
			} else {
				callback();
			}
		};
		return {
			options: [
				{
					label: '修改密码',
					value: 'fixpass'
				},
				{
					label: '退出登录',
					value: 'loginout'
				}
			],
			forgetparam: {
				//phone:"",
				lastpassword: '',
				password: '',
				surepassword: ''
			},
			forgetrules: {
				//phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
				lastpassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
				password: [{ trigger: 'blur', validator: validatePass }],
				surepassword: [{ required: true, message: '请再次输入密码', trigger: 'blur' }]
			},
			fixpassdiag: false,
			collapse: false,
			fullscreen: false,
			name: 'linxin',
			message: 2,
			useropj: {},
			selectData: [],
			selectDataDef: '',
			// udesk
			userId: '',
			userName: '',
			nickName: '',
			projectName: '',
			jllogoImg: 'jl_logo.png',
			familyLoginUrl: '',
			enableFamilyLogin: '',

            taxBureauLoginBtnShowFlag: false,
            taxBureauLoginDialog:false,
            taxBureauLoginForm:{
                nasrsbh:"",
                loginAccount:"",
                loginPassword:"",
                qiybh:"",
                smsCode:""
            },
		};
	},
	created() {
		(this.projectName = configHttp.projectName), (this.familyLoginUrl = configHttp.familyLoginUrl), (this.enableFamilyLogin = configHttp.enableFamilyLogin);
		this.projectName.toUpperCase();
		if (this.projectName == 'WGQ') {
			this.jllogoImg = 'jl_logo_wgq.png';
		}
        this.initTaxBureauData();
	},
	computed: {},
	methods: {
        //发送验证码
        sendSmsCode(){
            console.log("发送验证码。。。。。")
            this.$https.fetchGet('rpa/authCodeLogin', {qiybh:this.taxBureauLoginForm.qiybh}).then(res => {
                console.log(res);
                this.$message.success(res.data.data.returndata.msg);
            })
        },
        taxBureauLoginSubmit(){
            if (this.taxBureauLoginForm.smsCode == "") {
                this.$message.error('请输入验证码！');
                return;
            }
            this.$https.fetchGet('rpa/authCodeLogin', {qiybh:this.taxBureauLoginForm.qiybh,smsCode:this.taxBureauLoginForm.smsCode}).then(res => {
                console.log(res);
                if (res.data.code == '200') {
                    this.$message.success("登录成功");
                    this.closeTaxBureauLoginDialog();
                } else {
                    this.$message.error("验证码错误或失效！");
                }
            })
        },
        //税局登录
        taxBureauLogin(){
           this.initTaxBureauData();
            this.taxBureauLoginDialog = true;
        },
        initTaxBureauData(){
            let user = localStorage.getItem("useropj");
            let userInfo = JSON.parse(user);
            let code = userInfo.currCompany.code;
            this.$https.fetchPost('sys/admin/getCompanyStxx', code).then(res => {
                let resData = res.data.obj;
                if (resData.stxx.shudfpkpfs == "2") {
                    this.taxBureauLoginBtnShowFlag = true;
                    this.taxBureauLoginForm.nasrsbh = resData.stxx.nasrsbh;
                    this.taxBureauLoginForm.qiybh = resData.stxx.qiybh;
                    this.taxBureauLoginForm.loginAccount = resData.digitalRpaInfo.loginAccount;
                    this.taxBureauLoginForm.loginPassword = resData.digitalRpaInfo.loginPassword;
                } else {
                    this.taxBureauLoginBtnShowFlag = false;
                }
            });
        },
        closeTaxBureauLoginDialog(){
            this.taxBureauLoginForm.smsCode = "";
            this.taxBureauLoginDialog = false;
        },
		forchoose() {
			this.$refs['forgetparam'].validate(valid => {
				if (valid) {
					//填写修改密码
					if (this.forgetparam.password != this.forgetparam.surepassword) {
						this.$message.info('两次新密码不一致。');
						return;
					}
					let param = {};
					//param.phone=this.forgetparam.phone;
					param.originalPassword = this.encryptionPasswordAes(this.forgetparam.lastpassword);
					param.currentPassword = this.encryptionPasswordAes(this.forgetparam.password);
					this.$https.fetchPost('/sys/changePassword', param).then(
						res => {
							if (res.data.success) {
								localStorage.clear();
								this.$router.push('/login');
							}
						},
						error => {
							this.$message.error('修改密码错误：' + error);
						}
					);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 用户名下拉菜单选择事件
		handleCommand(command) {
			if (command == 'loginout') {
				// localStorage.removeItem('token');

				this.$https.fetchPost('/sys/loginout').then(
					res => {
						let portalLogin = localStorage.getItem('portalLogin');
						// 产品退出登录后跳转到门户网站
						if (this.enableFamilyLogin && (this.projectName == 'PRODUCT' || this.projectName == '') && portalLogin == 'true') {
							let token = localStorage.getItem('token');
							localStorage.clear();
							localStorage.setItem('portalLogin', portalLogin);
							window.location.href = this.familyLoginUrl + '?token=' + token;
						} else {
							this.$router.push('/login');
						}
					},
					error => {
						this.$message.error('切换实体错误：' + error);
					}
				);
			} else if (command == 'fixpass') {
				Object.keys(this.forgetparam).map(key => (this.forgetparam[key] = ''));
				this.fixpassdiag = true;
			}
		},
		// 侧边栏折叠
		collapseChage() {
			this.collapse = !this.collapse;
			bus.$emit('collapse', this.collapse);
		},
		// 全屏事件
		handleFullScreen() {
			let element = document.documentElement;
			if (this.fullscreen) {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
			} else {
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen();
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen();
				} else if (element.msRequestFullscreen) {
					// IE11
					element.msRequestFullscreen();
				}
			}
			this.fullscreen = !this.fullscreen;
		},
		getSwitchCompany(e) {
			this.$https.fetchPost('/sys/admin/getSwitchCompany', e).then(
				res => {
					if (res.data.success) {
						localStorage.setItem('useropj', JSON.stringify(res.data.obj));
						//this.$router.push('/');
						this.getCurrentUserMenuFunction();
					} else {
						this.$message.error('切换实体错误：' + res.data.message);
					}
				},
				error => {
					this.$message.error('切换实体错误：' + error);
				}
			);
		},
		/* 	获取用户展示权限菜单 */
		getCurrentUserMenuFunction() {
			let params = {};
			this.$https.fetchPost('sys/admin/getRoleMenuIdListByUser', params).then(res => {
				if (res.data.success) {
					localStorage.setItem('routearr', res.data.obj.routearr);
					localStorage.setItem('userFunction', JSON.stringify(res.data.obj.userFunction));
					this.saveStorageButton(res.data.obj.userFunction);
					this.$router.push('/');
					this.$router.go(0);
				}
			});
		},
		saveStorageButton(data) {
			let buttonIds = [];
			let userFunction = data;
			for (let i = 0; i < userFunction.length; i++) {
				if (userFunction[i].hasOwnProperty('children')) {
					let pageButtons = userFunction[i].children;
					for (let j = 0; j < pageButtons.length; j++) {
						if (pageButtons[j].hasOwnProperty('buttomroute')) {
							let keys = Object.keys(pageButtons[j].buttomroute);
							if (keys.length <= 0) {
								continue;
							}
							let buttonObjs = pageButtons[j].buttomroute;
							for (let key of keys) {
								buttonIds.push(key);
								let btnKeys = Object.keys(buttonObjs[key]);
								if (btnKeys.length <= 0) {
									continue;
								}
								for (let btnKey of btnKeys) {
									if (buttonObjs[key][btnKey]) {
										buttonIds.push(btnKey);
									}
								}
							}
						}
					}
				}
			}
			localStorage.setItem('buttonIds', JSON.stringify(buttonIds));
		},
		getCompanyByUserId() {
			this.selectData = [];
			this.$https.fetchPost('/sys/admin/getCompanyByUserId').then(
				res => {
					if (res.data.success) {
						for (let i = 0; i < res.data.obj.length; i++) {
							let data = {};
							data.id = res.data.obj[i].id;
							data.name = res.data.obj[i].name + '(' + res.data.obj[i].qiybh + ')';
							this.selectData[i] = data;
						}
						this.selectDataDef = res.data.obj[0].id;
					} else {
						this.$message.error('加载当前集团下企业数据错误：' + res.data.message);
					}
				},
				error => {
					this.$message.error('加载当前集团下企业数据错误：' + error);
				}
			);
		},
		getDistributeAlarmMessage() {
			this.$https.fetchPost('inventory/syncDistribute').then(res => {
				this.$https.fetchPost('inventory/syncDistributeAlarm').then(res => {
					this.$https.fetchPost('inventory/getDistributeAlarmMessage').then(messageRes => {
						if (messageRes.data.message !== '') {
							this.$notify({
								title: '库存预警',
								dangerouslyUseHTMLString: true,
								message: messageRes.data.message,
								offset: 100,
								type: 'warning',
								duration: 0
							});
						}
					});
				});
			});
		}
	},
	mounted() {
		this.useropj = JSON.parse(localStorage.getItem('useropj'));
		// 给tms-udesk 的属性赋值
		this.userId = this.useropj.id;
		this.userName = this.useropj.userName;
		this.nickName = this.useropj.userCode;
		console.log(this.useropj);
		// console.log(this.useropj)
		if (this.emptyandnull(this.useropj)) {
			return false;
		}
		this.getDistributeAlarmMessage();
		this.getCompanyByUserId();
		if (document.body.clientWidth < 1500) {
			this.collapseChage();
		}
	}
};
</script>
<style scoped lang="less">
.gongs {
	/deep/.el-input--small .el-input__inner {
		border: none;
		background-color: #242f42;
		width: 320px;
		color: #ffffff;
	}
}
.header-right-box-out {
	width: 140px;
	height: 50px;
	font-size: 14px;
	font-weight: 400;
	color: #ffffff;
	display: flex;
	cursor: pointer;
	.border {
		/deep/.el-input--small .el-input__inner {
			border: none;
			background-color: #354257;
			border-radius: 32px;
		}
		/deep/.el-icon-search {
			font-size: 19px;
			position: relative;
			top: 3px;
			margin-left: 17px;
		}
	}
}

.head-left {
	display: flex;
	align-items: center;
	margin-left: 30px;
	height: 50px;
	font-size: 18px;
	font-weight: 500;
	color: #ffffff;
}
.header {
	position: relative;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	width: 100%;
	height: 50px;
	font-size: 22px;
	color: #fff;
}
.collapse-btn {
	float: left;
	cursor: pointer;
	line-height: 50px;
}
.el-dropdown-menu__item--divided {
	border-top: 0px solid #ebeef5;
}
.header .logo {
	float: left;
	width: 180px;
	line-height: 50px !important;
	text-align: center;
}
.header .logo img {
	display: inline-block;
	height: 50px;
	vertical-align: middle;
}
.header-right {
	float: right;
	padding-right: 50px;
}
.header-user-con {
	display: flex;
	height: 50px;
	align-items: center;
}
.btn-fullscreen {
	transform: rotate(45deg);
	margin-right: 5px;
	font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
	position: relative;
	width: 30px;
	height: 30px;
	text-align: center;
	border-radius: 15px;
	cursor: pointer;
}
.btn-bell-badge {
	position: absolute;
	right: 0;
	top: -2px;
	width: 8px;
	height: 8px;
	border-radius: 4px;
	background: #f56c6c;
	color: #fff;
}
.btn-bell .el-icon-bell {
	color: #fff;
}
.user-name {
	margin-left: 10px;
}
.user-avator {
	margin-left: 20px;
}
.user-avator img {
	display: block;
	width: 40px;
	height: 40px;
	border-radius: 50%;
}
.el-dropdown-link {
	color: #fff;
	width: 140px;
	height: 32px;
	cursor: pointer;
}
.el-dropdown-menu__item {
	text-align: center;
}
.forgetall > div {
	display: flex;
}
.forgetall > div > img {
	width: 25px;
	height: 30px;
	margin-right: 30px;
}

.forgetall /deep/.el-input__inner {
	width: 276px;
	background-color: #ffffff;
	font-size: 13px;
	border-radius: 0px;
	padding: 0px;
	font-family: 'PingFang SC';
	font-weight: 500;
	color: #535f6d;
	border: 0px;
	border-bottom: 1px solid #e5e5e5 !important;
}
</style>
